<template>
  <div class="container">
    <PolygonLoader v-if="loading" />
    <div v-else>
      <h1>Changelog</h1>
      <div class="release" v-for="(release, i) in releases" :key="i">
        <div class="release__build">Release {{ release.buildNumber }}</div>
        <div class="release__date">{{ formatDate(release.timeStamp) }}</div>
        <div v-for="(value, key) in sections" :key="key">
          <template  v-if="release[key].length > 0">
            <p class="release__subheader">{{ value }}</p>
            <ul class="release__list">
              <li v-for="(commit, i) in release[key]" :key="i" v-html="formatMessage(commit.message)"></li>
            </ul>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import repository from '@/core/repository/repository'

export default {
  data: () => ({
    loading: true,
    releases: [],
    sections: {
      features: 'New features',
      fixes: 'Fixes',
      improvements: 'Improvements'
    }
  }),
  mounted() {
    repository.get('releasenotes').done(releases => {
      this.releases = releases
    }).always(() => {
      this.loading = false
    })
  },
  methods: {
    formatMessage(msg) {
      return msg.replace(/#[0-9]*/, match => `<a target="_blank" href="https://evry-polygon-portal.visualstudio.com/web-portal/_workitems/edit/${match.replace('#', '')}">${match}</a>`)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: measure(m);
}

h1 {
  text-transform: uppercase;
  background-color: color(primary);
  color: color(white);
  padding: 1rem;
}

.release {
  padding: 1rem;
  background-color: color(subtle);
  margin-top: 1rem;
}

.release__date {
  font-size: measure(xs);
}

.release__build {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  font-weight: 700;
  font-size: measure(m);
}

.release__release-name {
  text-transform: uppercase;
  font-weight: 700;
  margin-right: .6rem;
}

.release__subheader {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 700;
}

.release__list {
  padding: 0.5rem 1.5rem;
  margin: 0;
  font-size: measure(xs);
}

.release__list li {
  margin-bottom: .4rem;
}
</style>
